<template>
    <div class="lavelTabContentWrap">
        <LoadingOverlay :loading="loading" /> 
        <div class="lavelTab-topBox">
            <RichLevelUserInfoComponent />
        </div>
        <div class="lavelRule-infoBox">
            <h3 class="subHd">Level Rule</h3>
            <div class="title">The level is counted by the Diamonds you had recharged</div>
            <div class="lavelRule-tableWrap">
                <table>
                    <thead>
                        <tr>
                            <th>Rich Level</th>
                            <th>Diamonds Recharged</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="levelData in UserRichlevelData " :key="levelData.id">
                            <td>
                                <div class="userLabelBox">
                                    <img :src="getLevelImage(levelData.level)" class="lavelImage" alt="level icon" />
                                    <span class="uaserLabelVal">{{ levelData.level }}</span>
                                </div>
                            </td>
                            <td>{{ levelData.amount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import RichLevelUserInfoComponent from './RichLevelUserInfoComponent.vue'
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'RichLevel',
    components : {
        RichLevelUserInfoComponent,
        LoadingOverlay
    },
    data() {
        return {
            UserRichlevelData: [],
            loading: false,
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchUserRichlevelData'
    },
    mounted() {
        this.fetchUserRichlevelData();
    },
    methods: {
        fetchUserRichlevelData() {
            this.loading = true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/user-rich-charm-level-details?type=rich_level`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.UserRichlevelData = response.data.result.levellist;
                })

                .catch(error => {
                    console.error("Error Featching Rich Level Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getLevelImage(rich_lavel) {  
            switch (true) {
                case rich_lavel === 0:
                return require('@/assets/images/rich-lavel-0.png');
                case rich_lavel === 1:
                return require('@/assets/images/rich-lavel-1.png');
                case rich_lavel >= 2 && rich_lavel <= 10:
                return require('@/assets/images/rich-lavel-2.png');
                case rich_lavel >= 11 && rich_lavel <= 20:
                return require('@/assets/images/rich-lavel-3.png');
                case rich_lavel >= 21 && rich_lavel <= 30:
                return require('@/assets/images/rich-lavel-5-8.png');
                case rich_lavel >= 31 && rich_lavel <= 40:
                return require('@/assets/images/rich-lavel-12.png');
                case rich_lavel >= 41 && rich_lavel <= 50:
                return require('@/assets/images/rich-lavel-15.png');
                // case rich_lavel === 12:
                // return require('@/assets/images/rich-lavel-12.png');
                // case rich_lavel === 13:
                // return require('@/assets/images/rich-lavel-13.png');
                // case rich_lavel === 14:
                // return require('@/assets/images/rich-lavel-14.png');
                // case rich_lavel === 15:
                // return require('@/assets/images/rich-lavel-15.png');
                default:
                return require('@/assets/images/rich-lavel-0.png');
            }          
            // switch (true) {
            //     case rich_lavel === 0:
            //     return require('@/assets/images/rich-lavel-0.png');
            //     case rich_lavel === 1:
            //     return require('@/assets/images/rich-lavel-1.png');
            //     case rich_lavel === 2:
            //     return require('@/assets/images/rich-lavel-2.png');
            //     case rich_lavel === 3:
            //     return require('@/assets/images/rich-lavel-3.png');
            //     case rich_lavel === 4:
            //     return require('@/assets/images/rich-lavel-4.png');
            //     case rich_lavel >= 5 && rich_lavel <= 8:
            //     return require('@/assets/images/rich-lavel-5-8.png');
            //     case rich_lavel >= 9 && rich_lavel <= 11:
            //     return require('@/assets/images/rich-lavel-9-11.png');
            //     case rich_lavel === 12:
            //     return require('@/assets/images/rich-lavel-12.png');
            //     case rich_lavel === 13:
            //     return require('@/assets/images/rich-lavel-13.png');
            //     case rich_lavel === 14:
            //     return require('@/assets/images/rich-lavel-14.png');
            //     case rich_lavel === 15:
            //     return require('@/assets/images/rich-lavel-15.png');
            //     default:
            //     return require('@/assets/images/rich-lavel-0.png');
            // }      
        },
    },    
}
</script>